<template>
  <div class="py-1 container-fluid">
    <div class="row gx-4">
      <div class="mt-4 col-lg-3 mt-lg-0">
        <div class="card soft-card">
          <div class="soft-card-header">
            <h6>Filter</h6>
          </div>
          <div class="card-body">
            <label class="form-label">{{ $t("commonDate") }}</label>
            <div class="row mb-3 g-0">
              <el-date-picker v-model="date" type="daterange" unlink-panels range-separator="To"
                :start-placeholder="$t('commonStartDate')" format="DD.MM.YYYY" :end-placeholder="$t('commonEndDate')" :shortcuts="shortcuts"
                size="large" />
            </div>
            <div class="row mb-3 g-0">
              <label class="form-label">{{ $t("commonTypes") }}</label>
              <el-select v-model="typeId" multiple :placeholder="$t('commonSelect')" size="large">
                <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <el-checkbox v-model="meBox" :label="$t('commonCompany')" size="large" />
              </div>
              <div class="col-sm-4">
                <el-checkbox v-model="companyBox" :label="$t('insuranceLabel')" size="large" />
              </div>
              <div v-if="v$.box.$error" class="col-sm-5 text-danger mt-1">
                {{ $t("commonRequiredField") }}
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <button type="button" class="mb-0 action-btn action-btn--success action-btn--md action-btn--block" @click="searchHistory">
                  <i class="bi bi-search" aria-hidden="true"></i>
                  <span>{{ $t("commonSearch") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 col-lg-8 mt-lg-0">
        <timeline-list v-if="history.length > 0" title="Me" class="requests-timeline">
          <timeline-item v-for="h in history" :key="h" color="primary" icon="bookmark-plus-fill" :title="h.policyNumber"
            :date-time="h.created" :description="h.title" />
        </timeline-list>
        <div v-else class="d-flex justify-content-center align-items-center h-100">
          <p class="text-lg text-secondary mb-0">{{ $t("commonNoDataExcl") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Source from "@/project/Source/claim.js";
import TimelineList from "./components/TimelineList.vue";
import CryptoJS from "crypto-js";
import TimelineItem from "./components/TimelineItem.vue";
import useValidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'


export default {
  name: "Requests",
  components: { TimelineList, TimelineItem },
  data() {
    return {
      v$: useValidate(),
      tableVis: false,
      date: [new Date(new Date().setDate(new Date().getDate() - 2)), new Date()],
      types: null,
      companyBox: true,
      typeId: null,
      meBox: true,
      history: [],
      policyTables: [{ id: 1, index: 0 }, { id: 2, index: 1 }]
    }
  },
  validations() {
    return {
      box: {
        required: (this.companyBox == false && this.meBox == false) ? required : !required
      }
    }
  },
  mounted() {
    const data = {
      requestCorrelationId: "string",
    };
    Source.NotifTypes(data).then((response) => {
      this.types = response.data.data;
    })

    this.searchHistory()
  },
  methods: {
    searchHistory() {
      this.v$.$validate()
      if (this.v$.$error) { return }
      let appDateStart = []
      this.date.forEach((item, index) => {
        var year = item.getFullYear();
        var month = ("0" + (item.getMonth() + 1)).slice(-2);
        var day = ("0" + item.getDate()).slice(-2);

        appDateStart[index] = year + "-" + month + "-" + day + "T" + "00" + ":" + "00" + ":" + "00" + "." + "000" + "Z";

      })

      const historyData = {
        "requestCorrelationId": "string",
        "insuredId": JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("user"),
          "secret_key").toString(CryptoJS.enc.Utf8)).companyId,
        "notifType": (this.typeId && this.typeId.length) ? this.typeId.join(';') : null,
        "dateFrom": appDateStart[0],
        "dateTo": appDateStart[1],
        "filteruser": this.companyBox && this.meBox ? null : this.companyBox ? 2 : 1,
        "user": JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("user"),
          "secret_key").toString(CryptoJS.enc.Utf8)).userId
      }

      Source.Notifications(historyData).then((response) => {
        this.history = response.data.data;
      })
    }
  }
};
</script>
<style scoped>
.requests-timeline {
  max-height: 600px;
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0;
}
</style>
